<template>
  <div>
    <div class="head">
      Quatation Summary
    </div>

    <div class="wrap-box">
      <div class="filter-box">
        <div>
          <datepicker :format="calendarFormat"
            :class="['datepicker inline', {'has-error':!!validation.start}]"
            v-model="start" :disabled-picker="loading"
          ></datepicker>
          <span class="error-msg">{{validation.start}}</span>
        </div>
        <datepicker :format="calendarFormat"
          :class="['datepicker inline', {'has-error':!!validation.end}]"
          v-model="end" :disabled-picker="loading"
        ></datepicker>
        <button :disabeld="loading" @click="getSummary"
          :class="['button cta small', {disabled: loading}]" >
          Submit
        </button>
      </div>

      <table class="table-box" cellspacing="0">
        <thead>
          <th>Date</th>
          <th>API Call count</th>
          <th>Duration</th>
        </thead>
        <tbody>
          <tr v-if="!list.length">
            <td colspan="3" class="empty">No record found.</td>
          </tr>
          <tr v-for="dat in list">
            <td>{{dat.date}}</td>
            <td>{{dat.count}}</td>
            <td>{{dat.time}}s</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'admin-quotation-summary',
  components: { datepicker },
  data () {
    return {
      start: '',
      end: '',
      loading: false,
      validation: {
        start: '',
        end: ''
      },
      list: []
    }
  },
  computed: {
    disabledDate () {
      if (this.today.format('MM') === '01') {
        return {
          to: new Date(
            this.today.subtract(1, 'months').format('YYYY'),
            this.today.format('MM'),
            this.today.format('DD')
          )
        }
      }

      return {
        to: new Date(
          this.today.format('YYYY'),
          this.today.subtract(1, 'months').format('MM'),
          this.today.format('DD')
        )
      }
    },
  },
  methods: {
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    getSummary () {
      let self = this

      let start = moment(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0)
      let end = moment(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59)
      self.validation.start = ''
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.'
        return
      }

      self.loading = true
      self.$sdk.opt('/quotation/summary', {
        token: self.$store.state.session.sessionToken,
        startUnix: start.format('x'),
        endUnix: end.format('x')
      }, res => {
        self.loading = false
        let list = []
        if (!res.error) {
          res.segments.forEach(data => {
            list.push({
              date: moment(data.date, 'YYYY-MM-DD').format('MM/DD/YYYY'),
              count: data.requestCount,
              time: data.avgResponseTime
            })
          })
        }
        self.list = list
      })
    },
  },
  mounted () {
    this.start = moment().subtract(7, 'days').format('MM/DD/YYYY')
    this.end = moment().format('MM/DD/YYYY')
    this.getSummary()
  }
}
</script>

<style lang="scss" scoped>
.head{
  height: 50px;
  font-weight: 600;
  color: #fff;
  padding: 0 10px;
  width: calc(100% - 50px);
  margin-left: 50px;
  font-size: 21px;
  line-height: 50px;
  background: #333;
}
.wrap-box{
  width: 100%;
  max-width: 1100px;
  padding: 10px;
  margin: 0 auto;
}
.filter-box{
  display: flex;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 15px;
  border-radius: 4px;
  align-items: start!important;
  
  .error-msg{
    font-size: 13px;
    color: #f00;
  }
  .button{
    line-height: 20px;
    padding: 10px 20px;
  }
}
.datepicker{
  margin-right: 10px;
}

.table-box{
  margin-top: 30px;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;
  }
  td{
    padding: 7px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Quotation/index.vue